<template>
  <div>
    <div class="logo"></div>

    <div class="content-wrapper">
      <div class="content">
        <div class="title">Современная система лояльности</div>
        <div class="subtitle">Your Loy—</div>
        <div class="info">
          удобная и эффективная бонусная программа лояльности,
          превращает случайных посетителей в постоянных клиентов и
          мотивирует их покупать больше ваших товаров и услуг.
        </div>
      </div>

      <div class="footer">
        <div>
          © 2022, ООО «Комтет», официальный сайт
        </div>

        <div>
          <a class="footer__link" href="/legal/privacy-policy.pdf" target="_blank">
            Политика конфиденциальности
          </a>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {};
</script>

<style lang="scss" >
@font-face {
  font-family: GilroyExtraBold;
  src: url('~@/assets/fonts/Gilroy/ExtraBold/Gilroy-ExtraBold.otf');
}

@font-face {
  font-family: GilroyLight;
  src: url('~@/assets/fonts/Gilroy/Light/Gilroy-Light.otf');
}

@font-face {
  font-family: BloggerSans;
  src: url('~@/assets/fonts/BloggerSans/Regular/BloggerSans-Regular.otf');
}

body {
  margin: 0;
  padding: unset;
  background-image: url('~@/assets/images/background.jpg');
  background-position: 50%;
  background-size: cover;
  background-repeat: no-repeat;
  position: relative;
}

.logo {
  background-image: url('~@/assets/images/logo.svg');
  width: 99px;
  height: 60px;
  position: absolute;
  top: 50px;
  left: 60px;
}

.content-wrapper {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  max-width: 800px;
  background: rgba(31, 23, 66, 0.8);
  margin-left: auto;

  .content {
    max-width: 600px;
    margin: auto auto 50px;
    padding: 120px 20px 0;
  }

  .title {
    font-family: GilroyExtraBold;
    font-size: 48px;
    color: #fff;
    margin-bottom: 50px;
  }

  .subtitle {
    font-family: GilroyLight;
    font-size: 28px;
    color: #fff;
    margin-bottom: 13px;
  }

  .info {
    font-family: BloggerSans;
    font-size: 20px;
    line-height: 28px;
    color: #fff;
    margin-bottom: 32px;
  }

  .footer {
    font-family: BloggerSans;
    font-size: 16px;
    line-height: 22px;
    color: #848D92;
    text-align: center;
    max-width: 600px;
    margin: auto auto 48px;
    padding: 0 20px;

    &__link {
      color: #848d92;
      text-decoration: underline;
    }
  }
}

@media (max-width: 768px) {
  .title {
    font-size: 36px;
  }

  .info {
    font-size: 16px;
  }
}

@media (max-width: 480px) {
  .logo {
    left: 20px;
    top: 30px;
  }
}
</style>
